import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/lifestyle`} />
        <meta
          name="description"
          content={
            'Immerse yourself in the world of luxury living with First-Class.com. Discover lifestyle articles covering fashion, wellness, and more'
          }
        />
        <title>Lifestyle: Enhance Your Luxury Travel Lifestyle</title>
      </Head>
      <ArticlesList type="Lifestyle" heading="Lifestyle" />
    </>
  );
}

export default withLayout(TopLists, true);
